<div mat-dialog-title class="dialog-title-before-none" style="margin-top: 8px;">
  <div class="valign-wrapper">
    <span class="as-card-header">{{ data?.pageTitle }}
      <form action="#">
        <mat-radio-button name="categoryClassification" id="categoryClassificationEmergency" [checked]="categoryClassification === EMERGENCY" (change)="onCategoryClassificationChange(EMERGENCY)">
          <mat-label for="categoryClassificationEmergency">{{ 'Emergency' | translate:locale.language }}</mat-label>
        </mat-radio-button>
        
        <mat-radio-button name="categoryClassification" type="radio" id="categoryClassificationOperations" [checked]="categoryClassification === OPERATIONS" (change)="onCategoryClassificationChange(OPERATIONS)">
          <mat-label for="categoryClassificationOperations">{{ 'Operations' | translate:locale.language }}</mat-label>
        </mat-radio-button>
      </form>
    </span>
  </div>
</div>
<div mat-dialog-content>
  <div class="row">
    <div class="col s5">
      <span class="as-card-subheader" id="selectCategoryHeader" *ngIf="loadedMetadata">{{ 'Alert.Incident.SelectCategory' | translate:locale.language }}</span>
      
      <div class="center" *ngIf="loadedMetadata && !hasCategories">
        <br/><p class="as-no-selection" id="noCategories">{{ 'Alert.Incident.NoCategories' | translate:locale.language }}</p>
      </div>

      <!-- Loading metadata -->
      <div class="row loading-centered loading" *ngIf="!loadedMetadata">
        <app-loading [hasLoaded]="loadedMetadata" [hasFailed]="loadErrorMetadata" (retryClicked)="fetchMetadata()"></app-loading>
      </div>

      <div class="qa-categories collection" id="categoriesCollection" *ngIf="hasCategories">
        <ng-container *ngFor="let item of pageOfCategories">
          <a id="singleIncidentCategory" class="qa-categories collection-item as-blue-highlight" (click)="onCategorySelect(item)" [class.active]="item.id === selectedCategory?.id"
            (keydown.enter)="onCategorySelect(item)" (keydown.space)="$event.preventDefault(); onCategorySelect(item)" tabindex="0">{{ item.name }}</a>
        </ng-container>
      </div>

      <div *ngIf="hasCategories">
        <mat-paginator *ngIf="totalCategories > pageSize" id="incidentCategory" 
          [length]="totalCategories" [pageSize]="pageSize" [pageIndex]="currentCategoryPage - 1" [hidePageSize]=true
          (page)="onCategoryPageChange($event.pageIndex + 1)">
        </mat-paginator>
      </div>
    </div>
    <div class="col s5">
      <span class="as-card-subheader" id="selectTypeHeader" *ngIf="loadedMetadata">{{ 'Alert.Incident.SelectIncidentType' | translate:locale.language }}</span>
      
      <div class="center" *ngIf="loadedMetadata && !hasTypes">
        <br/><p class="as-no-selection" id="noTypes">{{ 'Alert.Incident.NoIncidentTypes' | translate:locale.language }}</p>
      </div>

      <div class="qa-types collection" id="typesCollection" *ngIf="hasTypes">
        <ng-container *ngFor="let item of pageOfTypes">
          <a id="singleIncidentType" class="qa-types collection-item as-blue-highlight" (click)="onTypeSelect(item)" [class.active]="isTypeSelected(item)"
            (keydown.enter)="onTypeSelect(item)" (keydown.space)="$event.preventDefault(); onTypeSelect(item)" tabindex="0">{{ item.name }}</a>
        </ng-container>
      </div>

      <div *ngIf="hasTypes">
        <mat-paginator *ngIf="categoryTypes?.length > pageSize" id="incidentType" 
          [length]="categoryTypes?.length" [pageSize]="pageSize" [pageIndex]="currentTypePage - 1" [hidePageSize]="true" 
          (page)="onTypePageChange($event.pageIndex + 1)">
        </mat-paginator>
      </div>
    </div>
  </div>
  <div *ngIf="data?.selectMultiple">
    <span class="as-card-subheader" id="selectCategoryHeader" *ngIf="loadedMetadata">{{ 'Tasklist.Form.SelectedIncidentTypes' | translate:locale.language }}</span>
    
    <ul  *ngIf="loadedMetadata && selectedEvents?.length" class="collection qa-incident-type-collection">

      <li *ngFor="let event of selectedEvents" app-selector-row [title]="event?.incidentType?.name"
        [showDrilldown]="false" [showCheckBox]="false"
        (selectedChange)="onClearType(event?.incidentType)">
      </li>
    </ul>

    <div *ngIf="loadedMetadata && !selectedEvents?.length" class="section">
      <p class="as-grey-text">{{ 'Tasklist.Form.NoIncidentTypesSelected' | translate:locale.language }}</p>
    </div>
  </div>
</div>
<div mat-dialog-actions class="right">
  <button mat-button id="cancel" color="primary" (click)="onCancelClick()">{{ 'Cancel' | translate:locale.language }}</button>
  <button *ngIf="data?.selectMultiple" mat-raised-button color="primary" id="okBtn" (click)="onDoneSelecting()">{{ 'OK' | translate:locale.language }}</button>
</div>
